import {EditRounded} from "@mui/icons-material";
import {Button, FormControl, Grid, IconButton, MenuItem, TextField} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useEventTypeValues} from "../../../../component/useEventTypeValues";
import {useStatusValues} from "../../../../component/useStatusValues";
import {DatePicker} from "@mui/x-date-pickers";
import {
    STATUS_CREATED,
    STATUS_FOUND,
    STATUS_IN_PROGRESS,
    STATUS_NOT_FOUND,
    STATUS_RECOVERED,
    STATUS_RELEASE,
    STATUS_UNDER_SEIZURE
} from "../../../../component/Constants";
import InvoicingDetails from "./InvoicingDetails";
import EventLocation from "./EventLocation";
import PlaceFound from "./PlaceFound";
import ComplainantDetails from "./ComplainantDetails";
import Other from "./Other";
import {useRecoilState} from "recoil";
import {EDITING} from "../../../../service/FinesSecurityRecoil";
import CustomModalBL from "../../../../component/CustomModalBL";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import RadioGroupComponent from "../../../../component/RadioGroupComponent";
import {calculateResidualDays} from "../../../../component/utils/Utils";
import {useHasScope} from "../../../../../../config/globalConfig";
import {
    THEFT_MISAPPROPRIATION_SCOPE_EDIT,
    THEFT_MISAPPROPRIATION_SCOPE_EDIT_STATE
} from "../../../../component/utils/AuthConstants";

const CardDetails = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const hasScope = useHasScope;
    const {register, watch, control, setValue, formState} = useFormContext();
    const [editing, setEditing] = useRecoilState(EDITING);
    const [eventStatusFiltered, setEventStatusFiltered] = useState<any[]>([]);
    const theftMisappropriate = props.theftMisappropriate;
    const [openCancelEventChanges, setOpenCancelEventChanges] = useState(false);
    const {getEventTypeValues} = useEventTypeValues();
    const {getStatusValues} = useStatusValues();
    const {isDirty: formIsDirty} = formState;

    const radioButtonOptions = [{
        id: 0,
        label: `${t("eventCard.theft")}`
    }, {
        id: 1,
        label: `${t("eventCard.misappropriation")}`
    }];

    const carStatusOptions = [{
        value: false,
        label: t("eventCard.no")
    }, {
        value: true,
        label: t("eventCard.yes")
    }];

    const getWreckLabel = (value: any) => {
        switch (value) {
            case true:
                return t("eventCard.yes");
            case false:
                return t("eventCard.no");
            default:
                return "-"
        }
    }

    const filterStatusInCreated = [STATUS_CREATED, STATUS_IN_PROGRESS];
    const filterStatusInProgress = [STATUS_IN_PROGRESS, STATUS_FOUND, STATUS_NOT_FOUND];
    const filterStatusFound = [STATUS_FOUND, STATUS_UNDER_SEIZURE, STATUS_RECOVERED];
    const filterStatusUnderSeizure = [STATUS_UNDER_SEIZURE, STATUS_RELEASE];
    const filterStatusRelease = [STATUS_RELEASE, STATUS_RECOVERED];
    const filterStatusNotFound = [STATUS_NOT_FOUND, STATUS_FOUND];
    const filterStatusRecovered = [STATUS_RECOVERED];

    function filterStatuses() {
        if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_CREATED) {
            return filterStatusInCreated;
        } else if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_IN_PROGRESS) {
            return filterStatusInProgress
        } else if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_FOUND) {
            return filterStatusFound
        } else if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_UNDER_SEIZURE) {
            return filterStatusUnderSeizure
        } else if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_RELEASE) {
            return filterStatusRelease
        } else if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_NOT_FOUND) {
            return filterStatusNotFound
        } else if (theftMisappropriate.eventStatus.eventStatusCode === STATUS_RECOVERED) {
            return filterStatusRecovered
        } else return [];

    }

    function enableStatusEditing() {
        return editing ? !hasScope(THEFT_MISAPPROPRIATION_SCOPE_EDIT_STATE) : true;
    }

    useEffect(() => {
        if (theftMisappropriate && theftMisappropriate.eventStatus) {
            setEventStatusFiltered(filterStatuses())
        }
    }, [watch("eventStatus.eventStatusCode")]);

    useEffect(() => {
        if (editing) {
            if (watch("eventStatus.eventStatusCode") === STATUS_CREATED) {
                setValue("eventStatus.eventStatusCode", STATUS_IN_PROGRESS);
            }
        }
    }, [editing]);

    return (

        <>
            <Grid container columnSpacing={3} rowSpacing={1}>
                <Grid item md={6} xs={6} sx={{mt: 2}}>
                    {t("tabs.cardDetails")}
                    {hasScope(THEFT_MISAPPROPRIATION_SCOPE_EDIT) &&
                        <>
                            {!editing &&
                                <Button size={"small"} color="accent" sx={{position: 'absolute', right: 40,}}
                                        onClick={() => setEditing(prevState => !prevState)}>
                                    <EditRounded fontSize="small"/>
                                    {t('buttons.edit')}
                                </Button>
                            }
                        </>
                    }
                </Grid>
                <Grid item xs={12}>
                    {!editing ?
                        <TextField
                            value={getEventTypeValues(watch("eventType.eventTypeCode"))}
                            disabled={true}
                            id="eventType"
                            label={t("filters.eventType")}
                            type="text"/>
                        :
                        <Controller
                            control={control}
                            name={"eventType.eventTypeCode"}
                            render={({field, fieldState}) => (
                                <FormControl>
                                    <RadioGroupComponent
                                        handleChange={field.onChange}
                                        options={radioButtonOptions}
                                        disabled={false} value={field.value}
                                        name={"eventType.eventTypeCode"}/>
                                </FormControl>
                            )}
                        />}
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        disabled={true}
                        InputLabelProps={{shrink: true}}
                        id="entryUser"
                        label={t("listColumns.entryUser")}
                        type="text"
                        {...register("entryUser")} />
                </Grid>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name={"openingDatetime"}
                        render={({field, fieldState}) => (
                            <DatePicker
                                label={t('listColumns.openingDate')}
                                value={field.value}
                                onChange={field.onChange}
                                disabled={true}
                                renderInput={(params) =>
                                    <TextField
                                        InputLabelProps={{shrink: true}}
                                        {...params}
                                        fullWidth
                                        disabled={true}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}/>}
                                inputFormat={"L"}/>
                        )}/>
                </Grid>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name={"closingDatetime"}
                        render={({field, fieldState}) => (
                            <DatePicker
                                label={t('listColumns.closingDate')}
                                value={field.value}
                                onChange={field.onChange}
                                disabled={true}
                                renderInput={(params) =>
                                    <TextField
                                        InputLabelProps={{shrink: true}}
                                        {...params}
                                        fullWidth
                                        disabled={true}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}/>}
                                inputFormat={"L"}/>
                        )}/>
                </Grid>
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name={"eventStatus.eventStatusCode"}
                        render={({field, fieldState}) => (
                            <TextField
                                fullWidth
                                InputLabelProps={{shrink: true}}
                                label={t('filters.status')}
                                select
                                disabled={enableStatusEditing()}
                                value={field.value}
                                onChange={field.onChange}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                            >
                                {eventStatusFiltered.map(((elem: any) => (
                                    <MenuItem key={elem} value={elem}>
                                        {getStatusValues(elem)}
                                    </MenuItem>
                                )))}
                            </TextField>
                        )}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        InputLabelProps={{shrink: true}}
                        disabled={true}
                        id="lostOfPossession"
                        label={t("eventCard.lostOfPossession")}
                        type="text"
                        value={watch("eventStatus.eventStatusCode") === STATUS_IN_PROGRESS ?
                            (watch("complaintDatetime") ? calculateResidualDays(watch("complaintDatetime")) : "-")
                            : "-"}/>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        id="daysFromRelease"
                        InputLabelProps={{shrink: true}}
                        label={t("eventCard.carRecovery")}
                        type="text"
                        disabled={true}
                        value={watch("eventStatus.eventStatusCode") === STATUS_RELEASE ?
                            watch("daysFromRelease") ? watch("daysFromRelease") : "-"
                            : "-"}/>
                </Grid>
                <Grid item xs={3}>
                    {!editing ?
                        <TextField
                            value={getWreckLabel(watch("isWreck"))}
                            disabled={true}
                            fullWidth
                            id="isWreck"
                            label={t("eventCard.isWreck")}
                            type="text"/>
                        :
                        <Controller
                            control={control}
                            name={"isWreck"}
                            render={({field, fieldState}) => (
                                <TextField
                                    fullWidth
                                    disabled={watch("eventStatus.eventStatusCode") !== STATUS_RECOVERED}
                                    required={watch("eventStatus.eventStatusCode") === STATUS_RECOVERED}
                                    name="isWreck"
                                    label={t('eventCard.isWreck')}
                                    select
                                    value={field.value}
                                    onChange={field.onChange}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                >
                                    {carStatusOptions?.map((a: any) => (
                                        <MenuItem key={a.value} value={a.value}>
                                            {a.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}
                        />}
                </Grid>

                <Grid item xs={12}>
                    <InvoicingDetails setTheftMisappropriate={props.setTheftMisappropriate}
                                      theftMisappropriate={props.theftMisappropriate}/>
                </Grid>
                <Grid item xs={12}>
                    <EventLocation theftMisappropriate={props.theftMisappropriate}/>
                </Grid>
                <Grid item xs={12}>
                    <PlaceFound theftMisappropriate={props.theftMisappropriate}/>
                </Grid>
                <Grid item xs={12}>
                    <ComplainantDetails setTheftMisappropriate={props.setTheftMisappropriate}
                                        theftMisappropriate={props.theftMisappropriate}/>
                </Grid>
                <Grid item xs={12}>
                    <Other theftMisappropriate={props.theftMisappropriate}/>
                </Grid>
            </Grid>
            {editing &&
                <Grid container item xs={12} rowSpacing={1} columnSpacing={3} sx={{paddingTop: "50px"}}
                      justifyContent={"flex-end"}>
                    <Grid item>
                        <Button variant={"outlined"} color={"accent"}
                                onClick={() => {
                                    if (editing && formIsDirty) setOpenCancelEventChanges(true);
                                    else setEditing(false);
                                }}>
                            {t('buttons.cancel')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button color={"accent"} type="submit">
                            {t('buttons.save')}
                        </Button>
                    </Grid>
                </Grid>}

            <CustomModalBL title={t('updateForm.unsavedChanges')}
                           content={t('updateForm.discardMessage')}
                           cancelButton={t('updateForm.discardChanges')}
                           saveButton={t('updateForm.keepEditing')}
                           isDisabled={false}
                           open={openCancelEventChanges}
                           titleIcon={<InfoRoundedIcon/>}
                           onClose={() => {
                               setOpenCancelEventChanges(false);
                               setEditing(false);
                           }}
                           onSave={() => {
                               setOpenCancelEventChanges(false);
                           }}
                           onCancel={() => {
                               setEditing(false);
                               setOpenCancelEventChanges(false);
                           }}

            />
        </>
    );
}

export default CardDetails;